import { OrderDraftIcon, BillIcon, InventoryIcon, TransferIcon, InventoryUpdatedIcon, LabelPrinterIcon } from '@shopify/polaris-icons';
import { Page, Layout, Card, InlineGrid } from '@shopify/polaris';
import Tile from './Tile';
import { useNavigate } from 'react-router';

import './Dashboard.css';

const Dashboard = () => {
    const navigate = useNavigate();
    const handleClick = (url) => {
        if (url) {
            navigate(url, {
                viewTransition: true,
            });
        } else {
            console.warn('No URL provided for button click');
        }
    };

    return (
        <Page fullWidth>
            <Layout.Section fullWidth>
                <Card>
                    <InlineGrid gap="400" columns={{ xs: 1, sm: 2, md: 2, lg: 3 }}>
                        <Tile
                            title="Cycle Counts"
                            icon={InventoryUpdatedIcon}
                            description="View, Create, or Preform Cycle Counts"
                            button={{ label: 'View', onClick: () => handleClick('/cycle-counts') }}
                            requiredPermission="ccView"
                        />

                        <Tile
                            title="Store to Store Transfers"
                            icon={TransferIcon}
                            description="View, Create, or Receive Inventory Transfers"
                            button={{ label: 'View', onClick: () => handleClick('/transfers') }}
                            requiredPermission="transferView"
                        />

                        <Tile
                            title="Purchase Orders"
                            icon={OrderDraftIcon}
                            description="View purchase orders and recieve shipments"
                            button={{ label: 'View', onClick: () => handleClick('/purchase-orders') }}
                            requiredPermission="poView"
                        />

                        <Tile
                            title="Programs"
                            icon={BillIcon}
                            description="Manage company voucher programs"
                            button={{ label: 'View', onClick: () => handleClick('/program-management') }}
                            requiredPermission="programView"
                        />
                        <Tile
                            title="Inventory Adjustments"
                            icon={InventoryIcon}
                            description="Manage Store inventory"
                            button={{ label: 'View', onClick: () => handleClick('/inventory-adjustments') }}
                            requiredPermission="adjView"
                        />

                        <Tile title="Print Labels" icon={LabelPrinterIcon} description="Search and print product labels" button={{ label: 'View', onClick: () => handleClick('/print-labels') }} />

                        {/*<Tile
                    <InlineGrid gap="400" columns={{ xs: 1, sm: 2, md: 2, lg: 3 }}>
                        <Tile
                            title="Purchase Orders"
                            icon={OrderDraftIcon}
                            description="View purchase orders and recieve shipments"
                            button={{ label: 'View', onClick: () => handleClick('/purchase-orders') }}
                        />

                        <Tile title="Programs" icon={BillIcon} description="Manage company voucher programs" button={{ label: 'View', onClick: () => handleClick('/program-management') }} />

                        {/*<Tile
                        title="Cycle Counts"
                        icon={TransactionIcon}
                        links={[{ to: '/counts', label: 'Link if you want one' }]}
                        button={{ label: 'View', onClick: () => handleClick('/counts') }}
                    />
                    
                    <Tile
                        title="Vouchers"
                        icon={ProductFilledIcon}
                        links={[{ to: '/vouchers', label: 'Link if you want one' }]}
                        button={{ label: 'View', onClick: () => handleClick('/vouchers') }}
                    />
                */}
                    </InlineGrid>
                </Card>
            </Layout.Section>
        </Page>
    );
};

export default Dashboard;
